import fetchDoiType from './type.js';
function parseDoiJson(data) {
  const res = {
    type: fetchDoiType(data.type, data)
  };
  const dateFields = ['submitted', 'issued', 'event-date', 'original-date', 'container', 'accessed'];
  dateFields.forEach(field => {
    const value = data[field];
    if (value && value['date-parts'] && typeof value['date-parts'][0] === 'number') {
      value['date-parts'] = [value['date-parts']];
    }
  });
  return Object.assign({}, data, res);
}
export { parseDoiJson as parse, parseDoiJson as default };